import BackboneElement from './BackboneElement';
import HealthcareServicePerDiemApplicableServices from '@/fhirworks/HealthcareServicePerDiemApplicableServices';
import merge from 'lodash/merge';

export default class HealthcareServicePerDiem extends BackboneElement {
    static __className = 'HealthcareServicePerDiem';

    __objectStructure = {
        charge: Number,
        minimumHoursPerServiceDay: Number,
        requiredMinimumServiceDays: Number,
        billableServiceDays: String,
        billingWindowStartDay: String,
        applicableServices: [HealthcareServicePerDiemApplicableServices],
    };

    constructor(constructJson, className = 'HealthcareServicePerDiem') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        if (!this.billableServiceDays) {
            this.billableServiceDays = 'All days';
        }
        if (!this.billingWindowStartDay) {
            this.billingWindowStartDay = 'Program admission day';
        }
        if (!this.applicableServices) {
            this.applicableServices = [];
        }

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
